export interface SliderConfig {
  slidesToShow: number;
  slidesToScroll: number;
  autoplay: boolean;
  autoplaySpeed: number;
  dots: boolean;
  arrows: boolean;
  infinite: boolean;
  responsive?: {
    breakpoint: number;
    settings: {
      slidesToShow: number;
      slidesToScroll: number;
    };
  }[];
}

export const defaultSliderConfig: SliderConfig = {
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  dots: false,
  arrows: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};

// Product slider configurations
export const productSliderConfig: SliderConfig = {
  ...defaultSliderConfig,
  slidesToShow: 4,
  dots: false,
  arrows: true
};

export const bannerSliderConfig: SliderConfig = {
  ...defaultSliderConfig,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: false
};

export const brandSliderConfig: SliderConfig = {
  ...defaultSliderConfig,
  slidesToShow: 6,
  autoplaySpeed: 2000,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
};